module.exports = __webpack_public_path__ + "img/sanmisidouwuguo.a6013f1f.jpg";